import * as taskName from './task-name'
import { createUIDefinition } from '../default-task-definition'
import * as processUI from '../../process-ui'


export default createUIDefinition({
    taskName: taskName.DO_SEPA_PAYMENT,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.SALES_ORDER_OVERVIEW_WIDGET,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.INITIAL_HESITATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.TREATMENT_PAYMENT_WIDGET,
        },
        {
            component: processUI.INVOICE_LIST_WIDGET,
        },
        {
            component: processUI.PAYMENT_LIST_WIDGET,
        },
        {
            component: processUI.STATE_TRANSITION_LOG_CONTAINER,
        },
    ],
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/do-sepa-payment.js